import { createSlice } from '@reduxjs/toolkit';
import FJAIVideoGeneratorData from '../../config/dataConfig/FJAIVideoGeneratorData.js';
import FJConstant from '../../constants/FJConstant.js';
import FJAppConstant from '../../constants/FJAppConstant.js';
import FJUtil from '../../util/FJUtil.js';

const AB_TEST_TAB_INDEX = FJUtil.isLocalhost() || window?.fjuser?.info?.id % 2 === 0 ? 0 : 1;

const defaultQuality = FJAIVideoGeneratorData.QUALITY_LISL[0].value;
const defaultDuration = FJAIVideoGeneratorData.DURATION_LIST[0].value;
const defaultCreditPrice = defaultQuality === 1 ? 2 : 7;
const defaultTotalCredit = defaultCreditPrice * defaultDuration;

export const FJSliceAIVideoGenerator = createSlice({
    name: 'AIVideoGenerator',
    initialState: {
        currentRatio: FJAIVideoGeneratorData.RATIO_LIST[0].name,
        currentQuality: defaultQuality,
        currentDuration: defaultDuration,
        tabIndex: AB_TEST_TAB_INDEX,
        tvTextValue: '',
        ivTextValue: '',
        originImage: {},
        uploadStatus: FJConstant.DEFAULT,

        inspireList: [],
        presetList: [],

        currentGenerateStatus: FJAppConstant.IDLE,
        currentTackId: null,
        generatingVideoNum: 0,
        isShowGeneratingVideoNum: false,
        ivFreeNum: 0,
        tvFreeNum: 0,
        sortType: 'all-videos',

        // 总消耗
        totalCredit: defaultTotalCredit,
        // 积分价格  个/s
        creditPrice: defaultCreditPrice,
    },
    reducers: {
        setSliceRatio: (state, action) => {
            state.currentRatio = action.payload;
        },
        setSliceQuality: (state, action) => {
            state.currentQuality = action.payload;
            state.creditPrice = action.payload === 1 ? 2 : 7;
            state.totalCredit = state.creditPrice * state.currentDuration;
        },
        setSliceDuration: (state, action) => {
            state.currentDuration = action.payload;
            state.totalCredit = state.creditPrice * action.payload;
        },
        setSliceTabIndex: (state, action) => {
            state.tabIndex = action.payload;
        },
        setSliceTVTextValue: (state, action) => {
            state.tvTextValue = action.payload;
        },
        setSliceIVTextValue: (state, action) => {
            state.ivTextValue = action.payload;
        },
        setSliceOriginImage: (state, action) => {
            state.originImage = action.payload;
        },
        setSliceUploadStatus: (state, action) => {
            state.uploadStatus = action.payload;
        },
        setSliceInspireList: (state, action) => {
            state.inspireList = action.payload;
        },
        setSlicePresetList: (state, action) => {
            state.presetList = action.payload;
        },
        setSliceCurrentGenerateStatus: (state, action) => {
            state.currentGenerateStatus = action.payload;
        },
        setSliceCurrentTackId: (state, action) => {
            state.currentTackId = action.payload;
        },
        setSliceGeneratingVideoNum: (state, action) => {
            state.generatingVideoNum = action.payload;
        },
        setSliceIsShowGeneratingVideoNum: (state, action) => {
            state.isShowGeneratingVideoNum = action.payload;
        },

        setSliceIVFreeNumCreationAction: (state, action) => {
            state.ivFreeNum = action.payload;
        },

        setSliceTVFreeNumCreationAction: (state, action) => {
            state.tvFreeNum = action.payload;
        },

        setSliceSortType: (state, action) => {
            state.sortType = action.payload;
        },
    },
});

export const {
    setSliceRatio,
    setSliceQuality,
    setSliceDuration,
    setSliceTabIndex,
    setSliceTVTextValue,
    setSliceIVTextValue,
    setSliceOriginImage,
    setSliceUploadStatus,
    setSliceInspireList,
    setSlicePresetList,
    setSliceCurrentGenerateStatus,
    setSliceCurrentTackId,
    setSliceGeneratingVideoNum,
    setSliceIsShowGeneratingVideoNum,
    setSliceIVFreeNumCreationAction,
    setSliceTVFreeNumCreationAction,
    setSliceSortType,
} = FJSliceAIVideoGenerator.actions;

export default FJSliceAIVideoGenerator.reducer;
